<template>
  <v-container
    fluid
    class="d-flex justify-center align-center"
    pa-md-4
    pa-2
    style="min-height: 10vh; border-radius: 0; overflow: auto"
  >
    <v-row class="d-flex justify-center">
      <v-col cols="12" sm="6" md="4" lg="10">
        <v-card rounded="0">
          <v-toolbar flat dense color="#005F95">
            <div>
              <!-- Small to Large Screens -->
              <h1
                class="Limit-Toolbar"
                :style="{
                  fontSize: isSmall ? '11px' : isMedium ? '16px' : '20px',
                }"
              >
                DINERS CLUB {{ product }} ONLINE APPLICATION
              </h1>
            </div>
          </v-toolbar>

          <v-container
            fluid
            style="border: 1px solid #ccc; border-radius: 0; padding: 16px"
          >
            <v-container fluid style="border-radius: 0; padding: 16px">
              <v-row>
                <v-col cols="12">
                  <h1 class="Credit-Limit-Approve" style="text-align: left">
                    {{ product }} DECLINED APPLICATION
                  </h1>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="13">
                  <p style="text-align: left">
                    Dear Client, your application has been declined. For more
                    information, please call our Member Services Contact Centre
                    on 0860 (DINERS) 346377 and quote your reference number:
                    <b>{{ refNumber }}</b
                    >.
                  </p>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-col cols="12" class="text-center">
                  <v-btn
                    style="border-radius: 0; width: 220px"
                    @click="gotoLandingPage()"
                    color="#005F95"
                    class="white--text"
                    href="https://www.dinersclub.co.za/"
                  >
                    CLOSE APPLICATION
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
/* eslint-disable */
import { useDisplay } from "vuetify/lib/framework.mjs";
import { ref, onBeforeMount, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from "axios"; // Import axios if not globally available
const { smAndDown, mdAndUp, lgAndUp } = useDisplay();
const isSmall = smAndDown;
const isMedium = computed(() => mdAndUp.value && !lgAndUp.value);
const product = ref("");
const router = useRouter();
const AppStatus = ref("Declined");
const userid = ref(sessionStorage.getItem("userid"));
today: new Date();
const BeyondSelected = ref(false);
const prodtype = ref("");
const refNumber =ref("");
const appStatus = ref("")
const apptype = ref("")

onBeforeMount(() => {
  // Get product type from session storage
  appStatus.value = sessionStorage.getItem("appStatus");
  prodtype.value = sessionStorage.getItem("prodtype");
  apptype.value = sessionStorage.getItem("apptype");



  if (apptype.value === "newapp") {
    refNumber.value = sessionStorage.getItem("refNumber");
  } else if (apptype.value === "continueapp") {
    refNumber.value = sessionStorage.getItem("incompleteRef");
  }

  const productMap = {
    platinum: "CREDIT CARD",
    shariah: "SHARI'AH CARD",
    beyond: "BEYOND CARD",
  };
  product.value = productMap[prodtype.value] || "CREDIT CARD";
  BeyondSelected.value = prodtype.value === "beyond";

  if (refNumber.value) {
    updateDeclineStatus();
  } else {
    router.push("/");
  }
});

const formatDateYYYYMMDD = (date) => {
  return date
    ? new Date(date).toISOString().split("T")[0].replace(/-/g, "")
    : "";
};
const updateDeclineStatus = async () => {
 
  const authToken = sessionStorage.getItem("authToken");

  if (!refNumber.value || !authToken) {
    console.log("Customer Reference Number or Auth Token Not Found");
    return;
  }

  try {
    const response = await axios.post(
      "/updateAppStatus",
      {
        _REFNUMBER: refNumber.value,
        _USER_ID: userid.value,
        _STATUS: AppStatus.value,
        _STATUSDATE: formatDateYYYYMMDD(today),
      },
      {
        headers: {
          Authorization: authToken,
        },
      }
    );

    // Pageloader.value = false;

    if (["UPDATED", "ADDED"].includes(response.data.data._RESPONSE)) {

    }
  } catch (error) {
    console.error("Error in updateAppStatus:", error);
    // Pageloader.value = false;
  }
};

const gotoLandingPage = () => {
  // Clear all session storage data
  sessionStorage.clear();
  // Navigate to landing page
  router.push("/");
};
</script>
<style>
.declinedoffer {
  background: url("../assets/images/Beyondform.jpg") no-repeat center center;
  background-size: cover;
  position: absolute;
  height: 100%;
  width: 100%;
}

#border {
  border-top: 3px solid #000;
}

@font-face {
  font-family: "GathamLight";
  src: url("@/assets/fonts/Gotham-Light.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Light.otf") format("opentype");
  font-display: swap;
}
p {
  text-align: left;
  font-family: "GathamLight";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

h1 {
  color: #041e42;
}
</style>
